import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import {ButtonLink} from './ButtonLink.tsx';
import {useTranslation} from 'react-i18next';

export const DownloadPdfButton: React.FC = () => {
  const {t} = useTranslation();

  return (
    <ButtonLink
      to="/print"
      startIcon={<DownloadOutlinedIcon />}
      variant="outlined"
      size="small"
      fullWidth
      sx={{justifyContent: 'flex-start', textTransform: 'none'}}
    >
      {t('download-pdf')}
    </ButtonLink>
  );
};
